var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10454_209781",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 22,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2883 5.86044C22.6844 6.23058 22.7134 6.84885 22.3538 7.25445L10.8469 20.2324C10.4738 20.6531 9.82733 20.6836 9.41627 20.3L1.71452 13.1109C1.31729 12.7401 1.28885 12.1199 1.65048 11.7144L2.40067 10.873C3.52114 9.61627 5.45616 9.52753 6.68695 10.6764L9.08669 12.9164C9.4981 13.3004 10.1453 13.2694 10.5181 12.8479L17.185 5.30982C18.3041 4.04454 20.2466 3.95218 21.4807 5.10557L22.2883 5.86044Z",
    fill: "url(#paint0_linear_10454_209781)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10454_209781)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#45C587"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10454_209781",
    x1: 11.0833,
    y1: 21,
    x2: 12.3133,
    y2: 2.5847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587579,
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.72
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.ffdd5fee707865a9a55d40048ce5310e.svg";
export { ForwardRef as ReactComponent };